import { render, staticRenderFns } from "./newAuthorization.vue?vue&type=template&id=44bef44e"
import script from "./newAuthorization.vue?vue&type=script&lang=js"
export * from "./newAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports